// extracted by mini-css-extract-plugin
export default {"primary":"#fd2e6a","secondary":"#181928"};